module.exports = __webpack_public_path__ + "img/trasnparent-bg.0e22cfe9.png";